const HEX_BY_BYTE: ReadonlyArray<string> = Array.from({ length: 256 }, (_, byte) =>
  byte.toString(16).padStart(2, "0"),
);

/**
 * Generate a RFC 4122 version 4 UUID.
 *
 * `crypto.randomUUID` is restricted to secure contexts, so it is missing
 * whenever the web app is served over plain HTTP from anything other than
 * `localhost` — a LAN host or a Tailscale name, for instance. Calling it
 * unguarded there throws `crypto.randomUUID is not a function`.
 *
 * `crypto.getRandomValues` carries no such restriction and is available in
 * every browser and Node version this project supports, so the fallback keeps
 * the same cryptographic quality rather than degrading to `Math.random`.
 */
export function randomUUID(): string {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  // Pin the version (4) and variant (RFC 4122) bits.
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;

  let out = "";
  for (let index = 0; index < 16; index += 1) {
    if (index === 4 || index === 6 || index === 8 || index === 10) {
      out += "-";
    }
    out += HEX_BY_BYTE[bytes[index] as number];
  }
  return out;
}
